export default () => {

  if(document.getElementById('caseModal')){
    const modal = document.getElementById('caseModal');
    const closeBtns = modal.querySelectorAll('.js-close');

    const splide = new Splide('#caseSplide', {
      type: 'slide',
      perPage: 1,
      arrows: true,
      pagination: true,
      speed: 600,
    }).mount();

    document.querySelectorAll('.js-close').forEach(el => {
      el.addEventListener('click', () => {
        document.getElementById('caseModal').classList.remove('is-open');
      });
    });

    // 開く（data-slideで制御）
    document.querySelectorAll('[data-open-case]').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        const index = Number(btn.dataset.slide) || 0;

        modal.classList.add('is-open');

        // 表示後に移動（重要）
        requestAnimationFrame(() => {
          splide.go(index);
          splide.refresh();
        });
      });
    });

    // 閉じる
    closeBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        modal.classList.remove('is-open');
      });
    });
  }

}
